import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import Select from "@/common/elements/InputElements/Select";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { getOptionsFromRefList } from "@/util/common_function";
import TextField from "@/common/elements/InputElements/TextField";
import CommonDatePicker from "@/common/elements/DatePicker";

const ClassificationInformation = ({ formData, updateFormData, disabled }) => {
  return (
    <>
      <section>
        <IntakeSectionHeader>
          <span>Classification</span>
        </IntakeSectionHeader>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem
              name={["detentionsArrestReports", 0, "classificationId"]}
              label="Classification"
              layout="vertical"
            >
              <Select
                options={getOptionsFromRefList(
                  "Anoka_S3_Custody_Risk",
                  false,
                  false,
                  true
                )}
                placeholder="Classification"
                showSearch={false}
                variant="outlined"
                disabled={disabled}
              />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              name={["detentionsArrestReports", 0, "classificationEffectiveDate"]}
              label="As of"
              layout="vertical"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY"
                format="MM/DD/YYYY"
                showTime={false}
                disabled={disabled}
              />
            </FormItem>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default ClassificationInformation;
